import React, { useEffect, useState} from "react"
import { useNavigate } from "react-router-dom";
import WOW from "wowjs";
import "animate.css";
import Map from '../images/graph-image.png'
import { REGISTRATION_ABI, REGISTRATION_ADDRESS, MATRIX_CONTRACT, MATRIX_ABI } from '../constants/contract'
import useWalletConnect from "../hooks/useWalletConnect";
import { Contract, isAddress } from "ethers";
import contractErrorHandler from "../hooks/contractErrorHandler";
import { useUser } from "../context/UserContext";

import Header from '../components/Header'

const Register = () => {

    const navigate = useNavigate();
    const { setUser, userData } = useUser();
    if (userData) navigate('/dashboard')
        
    function trimAddress(address, length = 4) {
        if (!address) return '';
        return `${address.slice(0, 2 + length)}...${address.slice(-length)}`;
      }

    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const [hasUpline, sethasUpline] = useState(false);

    const [uplineValue, setUplineValue] = useState('')
    useEffect(() => {
        new WOW.WOW().init();
    }, []);

    useEffect(() => {
      const queryParams = new URLSearchParams(window.location.search);
      const paramValue = queryParams.get('ref');
      if(paramValue){
        setUplineValue(paramValue);
      }
    }, []);

    const handleChange = (event) => {
        setUplineValue(event.target.value);
    };
    const { parseError } = contractErrorHandler();

    const {
        account,
        connectBrowserWallet,
        connectWalletConnect,
        disconnectWallet,
        connectionType,
        loading,
        signer
    } = useWalletConnect();
    

    const [value, setValue] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
   
    const handleLogin = async () => {
        try {
            if (!signer) return alert("Connect your wallet first");

            setError('');
            setSuccess('');
            setIsLoading(true);
            
            const contract = new Contract(MATRIX_CONTRACT, MATRIX_ABI, signer);

            const regContract = new Contract(REGISTRATION_ADDRESS, REGISTRATION_ABI, signer);

            const checkReg=await regContract.getUserDetails(account.address)

            if(checkReg.registered){
                
                //const userRec=await contract.getUserDetails(account.address)
                
                const result = await contract.getAllUserRecord(account.address);
                const referrals=await regContract.getDirectReferrals(account.address)
             
                const totalTeam=await regContract.getReferralCounts(account.address);
             
                const formatted = {
                   user: result?.[0],
                  income: result?.[1],
                 // earnings: result[2], */
                  userRecord: checkReg,
                  refs: referrals.length,
                  team: totalTeam?.[1]
                };
                
                // Save to the context
                setUser(formatted);
                
               navigate('/dashboard');

            }
            else{
                setError('You are not yet registered')
            }
            setIsLoading(false);
          } catch (err) {
            console.error("Error fetching user data:", err);
            setError(parseError(err))
          }
      };
    


    const handleSignup = async () => {
        try {
            if (!signer) return alert("Connect your wallet first");

            setError('');
            setSuccess('');
            setIsLoading(true);
            
            const contract = new Contract(REGISTRATION_ADDRESS, REGISTRATION_ABI, signer);
            let upline=uplineValue
            if (!hasUpline && upline === '') {
                setError('Enter upline address');

                setIsLoading(false);
                return
            }
            else if(hasUpline){
                upline='153870'
            }
            if (upline==null) {
                setError('Invalid upline id');
                setIsLoading(false);
                return;
            }

            // Estimate gas (optional but better UX)
           // const gasEstimate = await contract.register.estimateGas(upline);

            //const tx = await contract.register('0x06E0d1e5593D93b53B567e6f9c17e3847Ea2f873');
            //const receipt = await tx.wait(); 

            
            const tx = await contract.register(upline);
            const receipt = await tx.wait(); 

             setSuccess('Successfully Registered');


        } catch (err) {
            setError(parseError(err))
            console.log(err)
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <>
            <Header/>
            <section className="bg-secondary-100 ">
                <div className="h-fit py-10  px-4 md:px-6 lg:px-40">

                    <div className="lg:my-20 pt-20" >

                        <div className="grid grid-cols-12" >
                            <div className="col-span-12 md:col-start-1 md:col-span-5 text-white px-5 lg:px-10 flex flex-col items-center">
                                {!loading ?(
                                    <>{!account ? (
                                        <>

                                            <div className="text-center mb-3">

                                            <button className="bg-orange-500 rounded-xl py-2 text-xs px-4 font-psemibold mr-3" onClick={connectBrowserWallet}><i className="fa fa-link"></i> Connect</button>
                                                <button className="bg-blue-500 rounded-xl py-2 text-xs px-4 mr-4" onClick={connectWalletConnect}>Wallet Connect</button>
                                            </div>
                                        </>
                                    ):(
                                        <div onClick={disconnectWallet} className="bg-primary-100 pl-1 py-1 mb-4 rounded-3xl w-fit text-base text-white flex items-center wow animate__animated animate__fadeInUp">
                                        <div className="bg-primary rounded-full border-white text-base h-[25px] w-[25px] justify-center flex items-center">
                                            <i className="fa fa-check-circle text-secondary-100"></i></div>
                                        <div className="font-pregular text-xs mr-5 ml-2">
                                            {trimAddress(account?.address)}
                                        </div>
        
                                    </div>
                                    )
                                    }
                                    </>) : (
                                        <div className="text-center text-secondary"><i className="fa fa-spin fa-spinner"></i></div>
                                    )}


                                <h2 className="font-psemibold text-center mb-3 text-2xl wow animate__animated animate__zoomIn">REGISTER WITH
                                    <span className="text-secondary"> MARK MAN</span></h2>

                                <p className="text-sm font-pregular mb-3">Do you have an upline?</p>
                                <div><button onClick={() => sethasUpline(false)} className={`wow animate__animated animate__zoomIn rounded-xl mr-5 ${!hasUpline ? `bg-primary text-secondary-100` : `border border-primary`} shadow px-10 py-3 text-sm font-pmedium wow animate__animated animate__fadeInUp `} data--wow-delay="1s">YES</button>

                                    <button onClick={() => sethasUpline(true)} className={`wow animate__animated animate__zoomIn rounded-xl ${hasUpline ? `bg-primary text-secondary-100` : `border border-primary`} shadow px-10 py-3 text-sm font-pmedium wow animate__animated animate__fadeInUp`} data--wow-delay="1s">NO</button>
                                </div>
                                {!hasUpline ? (

                                    <input
                                        type="number"
                                        value={uplineValue}
                                        onChange={handleChange}
                                        className="border w-full wow animate__animated animate__zoomIn text-black mt-5 p-3 mb-4 rounded-lg w-80" placeholder="Inviter ID" />
                                ) :
                                    (<p className="font-pregular my-5 text-xs">Proceed to click on the register button to continue!</p>)
                                }
                                <div>
                                    {!isLoading ?
                                        (<button onClick={handleSignup} className="wow animate__animated animate__zoomIn rounded-xl bg-primary text-secondary-100 shadow px-10 py-3 text-sm font-pmedium wow animte__animated animate__fadeInUp" data--wow-delay="1s">Register</button>)
                                        :
                                        (<button className="wow animate__animated animate__zoomIn rounded-xl bg-primary text-secondary-100 shadow px-10 py-3 text-sm font-pmedium wow animte__animated animate__fadeInUp disabled" data--wow-delay="1s"><i className="fa fa-spin fa-spinner"></i></button>)
                                    }
                                </div>
                                {success && (<div className="text-center overflow-hidden mt-3 text-green-400">{success}</div>)}
                                
                                {error && (<div className="text-center overflow-hidden mt-3 text-xs text-red-400">{error}</div>)}
                                {/* 
                                    <div className="hor-line w-100 my-10"></div>

                                <h2 className="font-pmedium text-center mb-3 text-xl wow animate__animated animate__zoomIn text">Confirm User ID</h2>

                                    <input className="w-full wow animate__animated animate__zoomIn p-3 mb-4 rounded-lg w-80" placeholder="Enter User ID" />

                                <button className="wow animate__animated animate__zoomIn mb-5 rounded-xl bg-primary text-secondary-100 shadow px-10 py-3 text-sm font-pmedium wow animate__animated animate__fadeInUp" data--wow-delay="1s">View User</button>
 */}
                                <p className="font-pregular  mt-5 text-center">If you ARE already registered, click login button to see your dashboard
                                    <br/>
                                    <button className="bg-primary px-4 py-2 rounded-lg text-black mt-5 font-pmedium" onClick={handleLogin}>Login Dashboard</button></p>
                             
                            </div>

                            <div className="col-span-12 hidden md:block md:col-span-6 text-white h-40 oveflow-hidden md:px-10 md:px-0">
                                <img src={Map} className="w-full float mt-10 md:mt-0" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>


        </>

    )
}

export default Register;